/**
 * Countdown the number of characters remaining from user input
 * @param  {Node}   el         The wrapper element
 * @param  {Node}   inputEl    The input element
 * @param  {Node}   counterEl  The counter element
 * @param  {Object} props      Various options:
 *                               - {String} maxCharacters       Maximum characters
 *                               - {Bool}   showBackgroundFill  Apply background fill
 *
 * @return {Void}
 */
export default function characterCountdown(el, props) {
  const inputEl = el.querySelector(props.inputEl);
  const counterEl = el.querySelector(props.counterEl);
  const maxCharacters = props.maxCharacters;
  const showBackgroundFill = props.showBackgroundFill;

  /**
   * Calculate characters remaining
   */
  function numberOfCharactersRemaining() {
    let charactersRemaining = maxCharacters;
    let charactersTyped = inputEl.value.length;
    if (charactersTyped <= maxCharacters) {
      charactersRemaining = maxCharacters - charactersTyped;
    }
    return charactersRemaining;
  }

  /**
   * Calculate percentage remaining
   */
  function percentageRemaining() {
    let charactersTyped = inputEl.value.length;
    return (charactersTyped / maxCharacters) * 100;
  }

  /**
   * Pass percentage to input element as CSS variable
   */
  function setPercentageAsVar() {
    const percentage = percentageRemaining();
    return el.style.setProperty("--percentage", `${percentage}%`);
  }

  /**
   * Set `n characters remaining` string
   */
  function updateCharactersRemaining() {
    const n = numberOfCharactersRemaining();
    counterEl.innerHTML = n + " characters remaining";

    if (showBackgroundFill) {
      setPercentageAsVar();
    }
  }

  inputEl.addEventListener("input", updateCharactersRemaining);
  updateCharactersRemaining();
}
